import React from "react";
import { CirclePoint } from "../style";
import { OptionImage } from "../../product/style";

const ModuleExpoOverrides = ({ expoModuleOverrides }) => {
  if (!expoModuleOverrides || !expoModuleOverrides.selectedSides?.length) {
    return null;
  }

  return (
    <div className="px-1 pt-1" style={{ width: "max-content" }}>
      {expoModuleOverrides.selectedSides.map((side, index) => {
        const colorOption = expoModuleOverrides.selectedColors[index];

        return (
          <div key={side} className="d-flex align-items-center gap-2 pb-2">
            <strong style={{ textTransform: "capitalize" }}>{side} expo</strong>

            {colorOption && (
              <>
                <CirclePoint />
                <div className="d-inline-flex align-items-center gap-2 text-muted">
                  {colorOption.image && (
                    <OptionImage
                      src={colorOption.image}
                      alt={colorOption.short_name || colorOption.name}
                      className="border border-dark rounded-circle me-1"
                    />
                  )}
                  {colorOption.short_name}
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ModuleExpoOverrides;
